/**
 * Note Comments Contract — typed API contract for inline discussions.
 *
 * All types derived from generated Zod schemas (OpenAPI-first).
 * Maps to: core/app/schemas/note_comment.py
 */

import { z } from 'zod';

import {
  zNoteCommentResponse as GeneratedNoteCommentResponse,
  zNoteCommentCreate as GeneratedNoteCommentCreate,
  zNoteCommentUpdate as GeneratedNoteCommentUpdate,
} from '@/api/generated/hey-api/zod.gen';

// ─── Schemas ────────────────────────────────────────────────────────────────

export const NoteCommentDTOSchema = GeneratedNoteCommentResponse;
export type NoteCommentDTO = z.infer<typeof NoteCommentDTOSchema>;

export const CreateCommentRequestSchema = GeneratedNoteCommentCreate;
export type CreateCommentRequest = z.infer<typeof CreateCommentRequestSchema>;

export const UpdateCommentRequestSchema = GeneratedNoteCommentUpdate;
export type UpdateCommentRequest = z.infer<typeof UpdateCommentRequestSchema>;

// ─── Response types ─────────────────────────────────────────────────────────

export type NoteCommentListResponse = NoteCommentDTO[];
